import React from "react";

const SecuritySection = () => {
  return (
    <div className=" pt-12 mt-8"
    >
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center md:justify-between"
      >
        {/* Left Section */}
        <div className="md:w-1/2 md:mb-0">
          <h2 className="text-2xl md:text-3xl text-gray-500 font-bold mb-4">
            Manage with <span className="text-white">Security</span>
          </h2>
          <p className="text-white-900 text-xl mb-6 md:w-9/12">
            Pixell is audited and certified by industry-leading third-party
            standards.
          </p>
          {/* <div className="flex space-x-4">
            <button className="px-6 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition duration-200">
              Start for free
            </button>
            <button className="px-6 py-2 border border-black text-black rounded-md hover:bg-gray-100 transition duration-200">
              Talk to sales
            </button>
          </div> */}
        </div>

        {/* Right Section */}
        <div className="md:w-1/2 grid grid-cols-2 md:grid-cols-4 gap-6 justify-items-center place-items-center md:justify-items-end">
  <img
    src="/assests/images/LandingPage/security/img1.png"
    alt="GDPR Ready"
    className="w-16 md:w-20 filter invert"
  />
  <img
    src="/assests/images/LandingPage/security/img2.png"
    alt="CCPA Ready"
    className="w-16 md:w-20 filter invert"
  />
  <img
    src="/assests/images/LandingPage/security/img3.png"
    alt="ISO 9001 Certified"
    className="w-16 md:w-20 filter invert"
  />
  <img
    src="/assests/images/LandingPage/security/img4.png"
    alt="ISO 27001 Certified"
    className="w-16 md:w-20 filter invert"
  />
</div>

      </div>
    </div>
  );
};

export default SecuritySection;
